<template>
  <div id="homecontainter">
    <div class="pricing-header px-3 py-3 pt-md-5 pb-md-4 mx-auto text-center">
      <h1 class="display-4">Quiz</h1>
      <p class="lead">Welkom bij de quizpagina.<br /> Je kunt hier meedoen met een bestaande spel.</p>
    </div>
    <div class="container">
      <div class="card-deck mb-3">
        <!-- New Quiz -->
        <div class="card mb-4 box-shadow text-center">
          <div class="card-header">
            <h4 class="my-0 font-weight-normal">Bestaand spel</h4>
          </div>
          <div class="card-body">
            <form>
              <div class="form-group">
                <div v-bind:class="{ 'form-row' : (true), 'form-group' : (false)}">
                  <div v-bind:class="{ 'form-group col-md-8' : (true)}">
                    <label for="username">Vul hier je naam in:</label>
                    <input class="form-control" v-model="username" label="Je naam" type="text" required />
                  </div>
                  <div class="form-group col-md-4" v-if="(true)">
                    <label for="username">Game id:</label>
                    <input class="form-control" v-model="gameid" label="Game id" type="number" required />
                  </div>
                  <p v-if="errors.length" class="alert alert-danger">
                    <b>Los de volgende problemen op:</b>
                    <ul>
                      <li v-for="error in errors" v-bind:key="error">{{ error }}</li>
                    </ul>
                  </p>

                </div>
                <div class="form-row">
                  <div class="form-group col-md-4">
                    <label for="username">Kies hier je/uw kerkelijke wijk in Barneveld:</label>
                    <select class="form-control" v-model="district" label="Wijk">
                      <option>1</option>
                      <option>2</option>
                      <option>3</option>
                      <option>4</option>
                      <option>5</option>
                    </select>
                  </div>
                  <div class="form-group col-md-4">
                    <label for="username">Wat is je/uw leeftijd:</label>
                    <input class="form-control" v-model="age" label="Leeftijd" type="number" />
                  </div>
                  <div class="form-group col-md-4">
                    <label for="username">Kies hier je/uw geslacht:</label>
                    <select class="form-control" v-model="gender" label="Geslacht">
                      <option>Man</option>
                      <option>Vrouw</option>
                      <option>Onbekend</option>
                      <option>Overig</option>
                    </select>
                  </div>
                </div>
                <div>
                  <button v-if="isConnected" @click.prevent="handleSubmit('join')" type="submit" class="btn btn-primary mb-2">Meedoen</button>
                </div>
              </div>
            </form>
          </div>

          <ConnectionErrors />

        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ConnectionErrors from '@/components/ConnectionErrors.vue'

export default {
  name: 'home',
  computed: {
    ...mapGetters({
      isConnected: 'quiz/connected',
      gameError: 'quiz/gameError',
      connectionError: 'quiz/connectionError',
      isConnectionFailed: 'quiz/connectionFailed'
    })
  },
  components: {
    ConnectionErrors
  },
  data () {
    return {
      username: '',
      gameid: '',
      quiztype: 'join',
      district: '',
      age: 0,
      gender: '',
      errors: []
    }
  },
  methods: {
    changequiztype: function () {
      this.errors = []
    },
    leaveGames: function () {
      this.$store.dispatch('quiz/leaveGame')
    },
    handleSubmit (type) {
      // Validate input
      this.errors = []
      if (!this.username) this.errors.push('Naam is verplicht')
      if (!this.gameid) this.errors.push('Game id is verplicht')

      // Create object to send to store
      var data = {
        username: this.username,
        gameid: this.gameid,
        district: this.district,
        age: this.age,
        gender: this.gender
      }
      switch (type) {
        case 'join':
          this.$store.dispatch('quiz/joinGame', data)
          break
        case 'new':
          this.$store.dispatch('quiz/createGame', data)
          break
      };
    }
  }
}
</script>
